// The countries the site lists TV for, named the same way on every page that mentions them.
export const COVERAGE_COUNTRIES = "the US, UK, Germany, France, Sweden, Norway, Denmark and Finland";
